import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'preact/hooks';
import { useRouter } from 'preact-router';
import { useDispatch } from 'react-redux';

import { useFetchUserIfNeeded } from '@/components/Authorize/hooks';
import HabitatEmbedPanel from '@/components/HabitatEmbedPanel';
import { getHabitatQueryOptions } from '@/queries/habitats';
import { setHabitat, unsetHabitat } from '@/routes/habitat/actions';

import EmbeddedHabitatSearchBar from './SearchBar';

const EmbeddedHabitat = () => {
  const dispatch = useDispatch();
  const [{ matches }] = useRouter();
  const { data: habitat } = useQuery(getHabitatQueryOptions(matches?.habitatSlug));

  useFetchUserIfNeeded();
  useEffect(() => {
    if (!habitat) {
      return undefined;
    }
    dispatch(setHabitat({ habitat }));
    return () => {
      dispatch(unsetHabitat());
    };
  }, [habitat, dispatch]);

  return (
    <div className="relative flex flex-col md:flex-row">
      <div className="relative bg-primary-green text-white max-md:aspect-video md:h-[588px] md:grow">
        <video
          src={habitat?.heroVideoURL || habitat?.trailer?.videoURL}
          autoPlay
          muted
          loop
          className="preflight preflight-video size-full object-cover"
        />
        {/* Search bar */}
        <div className="absolute inset-0 items-center justify-center p-4 md:flex">
          <EmbeddedHabitatSearchBar placeholder={`Watch ${habitat?.animal ?? 'animals'} and more...`} />
        </div>
      </div>

      <div className="relative shrink-0 bg-white md:h-[588px] md:w-[380px]">
        {habitat && <HabitatEmbedPanel habitatId={habitat._id} animals={habitat.animals} />}
      </div>
    </div>
  );
};

export default EmbeddedHabitat;
